import Select from "./select";
import SelectSeparator from "./select_separator";

Select.Separator = SelectSeparator;

export default Select;
